import React from 'react';
import PropTypes from 'prop-types';
import {Subheader, Paper} from 'material-ui';
import style from '../../../../styles/styles';
import Info from "../../../common/Info/Info";
import withTranslation from "../../../../hoc/withTranslation";

const Timestamp = require('react-timestamp');

class AdminInfo extends React.Component {
    static propTypes = {
        admin: PropTypes.object.isRequired
    };

    render() {
        return (
            <Paper>
                <Subheader style={style.subHeader}>{this.props.t('generic.information')}</Subheader>
                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={this.props.admin.id}
                    />
                    <Info
                        title={this.props.t('user.username')}
                        content={this.props.admin.username}
                    />
                    <Info
                        title={this.props.t('user.email')}
                        content={this.props.admin.email}
                    />
                    <Info
                        title={this.props.t('user.firstname')}
                        content={this.props.admin.firstname}
                    />
                    <Info
                        title={this.props.t('user.lastname')}
                        content={this.props.admin.lastname}
                    />
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={this.props.admin.created_at} format='full' twentyFourHour/>}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            this.props.admin.updated_at &&
                            <Timestamp time={this.props.admin.updated_at} format='full' twentyFourHour/>
                        ) || this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
            </Paper>
        );
    }
}

export default withTranslation(AdminInfo);



// WEBPACK FOOTER //
// src/components/admin/AdminFull/AdminInfo/AdminInfo.js